import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { FunctionComponent, PropsWithChildren, useState } from 'react'
import { Colors } from '~/assets/style/colors'
import { Fonts } from '~/assets/style/fonts'
import { Transitions } from '~/assets/style/tokens'
import { WithClassName } from '~/types/utils'
import { Icon } from './Icon'
import { TrackingLabel } from './layout/ProductTrackingIntegration'

const VerticalTimelineItemHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 0;
`

const EventDate = styled.span`
  ${Fonts.P2}
  font-weight:700;
  cursor: pointer;
`

const Author = styled.div`
  display:flex;
  align-items: center;
  gap:4px;
  ${Fonts.P3}
  color: ${Colors.SlateGrey};
  padding-right: 12px;
`

const ContentWrapper = styled.div`
  border-left: 1px solid ${Colors.Platinum};
  margin-left: 9px;
  aspect-ratio: unset;
  min-height: 32px;
`

const CollapsibleIcon = styled(Icon)<{ opened?: boolean }>`
  margin:0 4px;
  ${Fonts.colors.King}
  cursor: pointer;
  transition: transform ${Transitions.quick};
  transform: rotate(${({ opened }) => (opened ? '-180deg' : '0')});
  :hover {
    ${Fonts.colors.Cobalt}
  }  
`

const VerticalTimelineItemWrapper = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
`

const CollapsibleContent = styled.div<{ isOpen: boolean }>`
  cursor: auto;
  padding: 4px 6px 16px 6px;
  ${({ isOpen }) =>
    !isOpen &&
    css`
      display: none;
    `}
`

type VerticalTimelineItemProps = WithClassName & {
  eventDate: string
  author?: string
  trackingLabel: TrackingLabel
}

const BaseVerticalTimelineItem: FunctionComponent<PropsWithChildren<VerticalTimelineItemProps>> = ({ className, eventDate, author, trackingLabel, children }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <VerticalTimelineItemWrapper
      className={className}
      onClick={(event) => {
        event.preventDefault()
        setIsOpen(!isOpen)
      }}
      data-tracking={trackingLabel}
    >
      <VerticalTimelineItemHeader>
        <EventDate>
          <CollapsibleIcon opened={isOpen} width={'10px'} name={'chevronDownCircle'} />
          {eventDate}
        </EventDate>
        <Author>
          <Icon name={'person'} width={'18px'} />
          {author}
        </Author>
      </VerticalTimelineItemHeader>
      <ContentWrapper>
        <CollapsibleContent isOpen={isOpen}>{children}</CollapsibleContent>
      </ContentWrapper>
    </VerticalTimelineItemWrapper>
  )
}

export const VerticalTimelineItem = styled(BaseVerticalTimelineItem)``
